import { QUERY_KEYS } from 'api/query-keys';
import { branchOfficeService } from 'ogp/services';
import { useQuery } from 'react-query';

const useGetBranchOfficeCreateData = () => {
  const queryFn = async () => await branchOfficeService.getBranchOfficeCreateData();

  return useQuery(QUERY_KEYS.brachOfficeCreateData(), queryFn);
};

export { useGetBranchOfficeCreateData };
